module.exports = __webpack_public_path__ + "img/attach.c4b64097.svg";